import StatusPill from '../StatusPill';

const Certifications = ({
    t,
    certifications,
}) => (
    <div className="overview-esg-rating__side-panel">
        <p className="overview-esg-rating__eyebrow mb-3">
            {t('ESG Certifications')}
        </p>
        {(certifications || []).map((item) => (
            <div
                key={item.name}
                className="overview-esg-rating__document"
            >
                <div className="d-flex justify-content-between align-items-center gap-2 mb-1">
                    <span className="overview-esg-rating__document-title">
                        {item.name}
                    </span>
                    <StatusPill
                        label={t(item.badge)}
                        color={item.badgeColor}
                    />
                </div>
                <span className="overview-esg-rating__document-meta">
                    {item.description}
                </span>
            </div>
        ))}
    </div>
);

export default Certifications;
